import {CodecTypes, Pikaparam} from 'pikaparam';

import {bleLog} from '../../../utils/Logger';

export interface IUnitClient {
  read<V extends CodecTypes>(key: string): Promise<V>;
  write<V extends CodecTypes>(key: string, value: V): Promise<V>;
}

export class UnitClient implements IUnitClient {
  constructor(private pikaparam: Pikaparam) {}

  public async read<V extends CodecTypes>(key: string) {
    bleLog.info(`getInApiThrow(${String(key)}).readOnce`);

    const value = await this.pikaparam.param.getInApiThrow<V>(key).readOnce();

    return value;
  }

  public async write<V extends CodecTypes>(key: string, value: V) {
    bleLog.info(`getInApiThrow(${key.toString()}).set`, {value});

    await this.pikaparam.param.getInApiThrow(key).set(value, false);

    return value;
  }
}
